module.exports = __webpack_public_path__ + "img/IJR_Mudancas_Fretes_f1-150x150.fc257f3a.webp";